module.exports = __webpack_public_path__ + "img/descuentos.616c8f3f.png";